import { IApprovalRequestDetail, IApprovalRequestListItem } from "../types";

const asArray = (value: unknown): IApprovalRequestListItem[] => {
  if (Array.isArray(value)) return value as IApprovalRequestListItem[];
  return [];
};

export const unwrapApprovalRequestList = (
  data: unknown,
): { items: IApprovalRequestListItem[]; total: number } => {
  if (!data) {
    return { items: [], total: 0 };
  }

  if (Array.isArray(data)) {
    return { items: data as IApprovalRequestListItem[], total: data.length };
  }

  const payload = data as Record<string, unknown>;
  const nested = payload.data ?? payload.response;

  if (Array.isArray(nested)) {
    const total =
      Number(payload.total ?? payload.count ?? payload.total_count) ||
      nested.length;
    return { items: nested as IApprovalRequestListItem[], total };
  }

  if (nested && typeof nested === "object") {
    const nestedObj = nested as Record<string, unknown>;
    const items = asArray(
      nestedObj.results ?? nestedObj.data ?? nestedObj.items,
    );
    const total =
      Number(
        nestedObj.total ??
          nestedObj.count ??
          nestedObj.total_count ??
          payload.total ??
          payload.count,
      ) || items.length;
    return { items, total };
  }

  const items = asArray(payload.results ?? payload.items);
  const total =
    Number(payload.total ?? payload.count ?? payload.total_count) ||
    items.length;

  return { items, total };
};

export const unwrapApprovalRequestDetail = (
  data: unknown,
): IApprovalRequestDetail | null => {
  if (!data) return null;
  if (typeof data !== "object") return null;

  const payload = data as Record<string, unknown>;
  if (payload.data && typeof payload.data === "object") {
    return payload.data as IApprovalRequestDetail;
  }

  return data as IApprovalRequestDetail;
};
